import axios from "axios";
import { defineStore } from "pinia";

const url = process.env.VUE_APP_API_URL;

let url_api = url;

export const useSupplierStore = defineStore("solicitationsupplier", {
  state: () => ({
    id: null,
    id_solicitacao: null,
    codigo: null,
    id_empresa: null,
    razaoSocial_empresa: null,
    id_fornecedor: null,
    razaoSocial_fornecedor: null,
    razaoSocial: null,
    descricao: null,
    unidade: null,
    quantidade: null,
    vlrunitario: null,
    valorTotalPedido: null,
    vlrTotalavista: null,
    vlrTotalaprazo: null,
    vlrTotaldebito: null,
    vlrTotalcredito: null,
    dt_emissao: null,
    dt_retirada: null,
    dt_entrega: null,
    situacao: null,
    id_item: null,
    id_prod_item: null,
    descricao_item: null,
    unidade_item: null,
    quantidade_item: null,
    valor_totalP_item: null,
    deleted_at: null,
  }),
  actions: {
    setSolicitationsupplierIdDetails(res) {
      //Busca do banco de dados
      // console.log("setSolicitationIdDetails", res.data);
      this.$state.id = res.data.id;
    },
    async fetchByIdSolicitationsupplier(id) {
      let res = await axios.get(url_api + "/api/salesorderentry/" + id);
      // console.log(res.data);
      this.$state.id = res.data.salesorderentry.id;
      this.$state.situacao = res.data.salesorderentry.situacao;
      if (res.data.salesorderentry.company) {
        this.$state.id_empresa = res.data.salesorderentry.company.id;
        this.$state.razaoSocial_empresa =
          res.data.salesorderentry.company.razaoSocial;
      } else {
        this.$state.id_empresa = 0;
        this.$state.razaoSocial_empresa = null;
      }
      if (res.data.salesorderentry.supplier) {
        this.$state.id_fornecedor = res.data.salesorderentry.supplier.id;
        this.$state.razaoSocial_fornecedor =
          res.data.salesorderentry.supplier.razaoSocial;
      } else {
        this.$state.id_fornecedor = 0;
        this.$state.razaoSocial_fornecedor = null;
      }
      this.$state.dt_emissao = res.data.dt_emissao;
      this.$state.dt_retirada = res.data.dt_retirada;
      this.$state.dt_entrega = res.data.dt_entrega;
      this.$state.valorTotalPedido = res.data.salesorderentry.valorTotalPedido;
      this.$state.vlrTotalavista = res.data.salesorderentry.vlrTotalavista;
      this.$state.vlrTotalaprazo = res.data.salesorderentry.vlrTotalaprazo;
      this.$state.vlrTotaldebito = res.data.salesorderentry.vlrTotaldebito;
      this.$state.vlrTotalcredito = res.data.salesorderentry.vlrTotalcredito;
    },

    async fetchListItemSolicitationsupplier(id) {
      let resItem = await axios.get(url_api + "/api/salesoitementrylist/" + id);
      // console.log(res.data);
      this.$state.id_item = resItem.data.id;
      this.$state.id_pedido_item = resItem.data.id_pedido_item;
      this.$state.id_prod_item = resItem.data.id_prod_item;
      this.$state.nome_produto_item = resItem.data.nome_produto;
      this.$state.codigo_barra_item = resItem.data.codigo_barra;
      this.$state.unidade_item = resItem.data.unidade;
      this.$state.quantidade_item = resItem.data.quantidade;
      this.$state.valor_unitario_item = resItem.data.valor_unitario;
      this.$state.valor_totalP_item = resItem.data.valor_totalProduto;
    },

    clearIdSolicitationsupplier() {
      this.$state.id_solicitacao = null;
      this.$state.codigo = null;
      this.$state.id_razaoSocial = null;
      this.$state.unidade = null;
      this.$state.quantidade = null;
      this.$state.unidade = null;
      this.$state.vlrunitario = null;
      this.$state.vlrtotal = null;
      this.$state.dt_emissao = null;
      this.$state.dt_retirada = null;
      this.$state.dt_entrega = null;
      this.$state.id_item = null;
      this.$state.id_prod_item = null;
      this.$state.descricao_item = null;
      this.$state.unidade_item = null;
      this.$state.quantidade_item = null;
      this.$state.situacao = null;
      this.$state.deleted_at = null;
    },
  },
  persist: true,
});
